import { useState } from "react";
import { useSnackbar } from "./use-snackbar";

export const useFileState = () => {
    const [file, setFile] = useState<File | null>(null);
    const snackbar = useSnackbar();

    const validateFile = (file: File) => {
        const validExtensions = ['.csv'];
        const fileExtension = file.name.split('.').pop();

        const maxSize = 5 * 1024 * 1024;
        if (!validExtensions.includes(`.${fileExtension}`)) {
            snackbar.show('', 'Tipo de ficheiro inválido. Por favor, faça upload de um ficheiro CSV.', 'error');
            return false;
        }
        if (file.size > maxSize) {
            snackbar.show('', 'O tamanho do ficheiro excede o limite de 5MB.', 'error');
            return false;
        }
        return true;
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            if (!validateFile(file)) return;
            setFile(file);
        }
    };

    const clearFile = () => {
        setFile(null);
    };

    return { file, handleFileChange, clearFile };
};